import React, { useEffect, useRef, useState } from "react";
import styles from "../styles/UsersList.module.css";
import { MdOutlineManageAccounts } from "react-icons/md";
import { IoIosSearch } from "react-icons/io";
import { RxDotsHorizontal } from "react-icons/rx";
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, InputAdornment, Box, Button, useTheme, IconButton, Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@mui/material";
import AddEditRoleModal from "../components/AddEditRoleModal";
import editLogo from "../assets/EditIcon.svg";
import deleteLogo from "../assets/delete.svg";
import moment from "moment";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";
import { useDispatch } from "../store";
import { Skeleton } from "@mui/material";
import PaginationComponent from "components/ui-components/PaginationComponent";
import { useParams } from "react-router-dom";
import ClearIcon from "@mui/icons-material/ClearOutlined";
import { useGetAllRoleQuery, useDeleteRoleMutation } from "store/slices/apis/rolePackageSlice";
import { usePermission } from "hooks/usePermission";
import { ROLE_ADD, ROLE_EDIT, ROLE_DELETE } from "config";
import {ReactComponent as SearchIcon} from "assets/PwC_Funct_Icons_Search_Outline_Black_RGB.svg"
import {ReactComponent as AddRoleIcon} from "assets/PwC_Funct_Icons_Plus_Outline_Black_RGB.svg"
import {ReactComponent as HorizontalIcon} from "assets/PwC_Funct_Icons_MoreHorizontal_Outline_Black_RGB.svg"
import {ReactComponent as CrossIcon } from "assets/PwC_Funct_Icons_Close_Outline_Black_RGB.svg"
import { ReactComponent as EditIcon } from "assets/PwC_Funct_Icons_Edit_Outline_Black_RGB.svg"
import {ReactComponent as DeleteIcon} from "assets/PwC_Funct_Icons_Delete_Outline_Black_RGB.svg"

const Role = () => {
    const inputRef = useRef();
    const rolesRef = useRef();
    const theme = useTheme();
    const dispatch = useDispatch();
    const [openModal, setOpenModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [openOptions, setOpenOptions] = useState(false);
    const [clickedUserId, setClickedUserId] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [pageNumber, setPageNumber] = useState(1);
    const pageSize = 10;
    const { projectId } = useParams();
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [roleToDelete, setRoleToDelete] = useState(null);

    const addRoleAction = usePermission(ROLE_ADD);
    const editRoleAction = usePermission(ROLE_EDIT);
    const deleteRoleAction = usePermission(ROLE_DELETE);

    const { data: allRole, error, isLoading } = useGetAllRoleQuery({
        projectId: projectId,
        //page: pageNumber,
        //pageSize: 10,
    });

    const [deleteRole, { isLoading: isDeleting, error: deleteError }] = useDeleteRoleMutation();

    const clearSearch = () => {
        setSearchQuery("");
    };

    const filteredUsers = allRole?.data?.filter((user) => {
        const query = searchQuery.trim().toLowerCase();


        const matchesSearchQuery =
            user?.displayName?.trim().toLowerCase().includes(query);

        return matchesSearchQuery;
    });

    const openNotification = async (msg, type = "error") => {
        await dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: "alert",
                alert: { color: type },
                close: false,
            })
        );

        setTimeout(() => dispatch(closeSnackbar()), 10000);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleOptions = (userId, e) => {
        e.stopPropagation();
        if (clickedUserId === userId) {
            setOpenOptions(!openOptions);
        } else {
            setClickedUserId(userId);
            setOpenOptions(true);
        }
    };

    const handleOpenModal = (user = null) => {
        setSelectedUser(user);
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setSelectedUser(null);
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            // if (rolesRef.current && !rolesRef.current.contains(e.target)) {
            //     setOpenRoleDropdown(false);
            // }
            if (inputRef.current && !inputRef.current.contains(e.target)) {
                setOpenOptions(false);
            }
        };

        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);


    const handleSaveUser = () => {
        handleCloseModal();
    };

    const confirmDeleteRole = (roleId) => {
        setRoleToDelete(roleId);
        setConfirmOpen(true);
    };

    const handleConfirmedDelete = async () => {
        try {
            const response = await deleteRole(roleToDelete).unwrap();
            if (response?.status === 'Success') {
                openNotification(response?.message || "Role deleted successfully.", 'success');
            }
            else {
                openNotification(response?.message || "Delete failed.");
            }

        } catch (error) {
            openNotification(error?.message);
        } finally {
            setConfirmOpen(false);
            setRoleToDelete(null);
        }
    }

    const handleCancelDelete = () => {
        setConfirmOpen(false);
        setRoleToDelete(null);
    };

    return (
        <div className={styles.container}>
            <div className={styles.top}>
                <div className={styles.info}>
                    <div className={styles.infoTag}>Role List</div>
                </div>
            </div>
            <div className={styles.list}>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: { xs: 'start', sm: "center" },
                        justifyContent: "space-between",
                        gap: "20px",
                        flexDirection: { xs: 'column', sm: 'row' },
                    }}
                >
                    <TextField
                        value={searchQuery}
                        onChange={handleSearchChange}
                        placeholder="Search"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                  {/* <IoIosSearch className={styles.searchIcon} /> */}
                                    <SearchIcon style={{ height: "20px", width: "20px", fill:"#808080" }} />
                                </InputAdornment>
                            ),
                            style: {
                                fontSize: "16px",
                            },
                            endAdornment: searchQuery?.length > 0 && (
                                <IconButton onClick={clearSearch} edge="end">
                                    {/* <ClearIcon style={{ fontSize: "16px" }} /> */}
                                   <CrossIcon style={{ fontSize: "20px", width:"20px", height:"20px", fill:"#808080" }} />
                                </IconButton>
                            ),
                        }}
                        sx={{
                            width: { xs: "100%", sm: '32%' },
                            height: "48px",
                            maxWidth: "500px",
                            background: "#fff",
                            "& .MuiInputBase-root": {
                                height: "48px",
                            },
                            "& .MuiInputBase-input": {
                                fontSize: "16px",
                                lineHeight: "20px",
                                fontWeight: "400",
                                color: "#696969",
                                opacity: 1,
                            },
                            "& .MuiInputBase-input::placeholder": {
                                fontSize: "16px",
                                lineHeight: "20px",
                                fontWeight: "400",
                                color: "#696969",
                                opacity: 1,
                            },
                        }}
                    />
                    {addRoleAction &&
                        <Button
                            sx={{
                                backgroundColor: theme?.customSettings?.themeColor,
                                color: "#FFF",
                                fontWeight: 400,
                                fontSize: "16px",
                                lineHeight: "24px",
                                padding: "8px 24px 8px 24px",
                                textTransform: "none",
                                borderRadius: "5px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "8px",
                                whiteSpace: "nowrap",
                            }}
                            onClick={() => handleOpenModal()}
                        >
                            {/* <MdOutlineManageAccounts fontSize="large" /> */}
                            <AddRoleIcon style={{ height:"20px", width:"20px", fill :"#FFFFFF", }}  />
                            Add roles
                        </Button>
                    }

                    <AddEditRoleModal
                        open={openModal}
                        handleClose={handleCloseModal}
                        user={selectedUser}
                        onSubmit={handleSaveUser}
                    />
                </Box>
                <Box>
                    <TableContainer component={Paper} className={styles.table}>
                        <Table>
                            <TableHead className={styles.table_head}>
                                <TableRow className={styles.table_row}>
                                    <TableCell
                                        className={`${styles.table_header} ${styles.table_header_admin}`}
                                    >
                                        &nbsp;Role Name
                                    </TableCell>
                                    {(editRoleAction || deleteRoleAction) &&
                                        <TableCell
                                            className={`${styles.table_header} ${styles.table_header_login}`}
                                        >
                                            Action
                                        </TableCell>
                                    }

                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {isLoading ? (
                                    [...Array(5)].map((_, index) => (
                                        <TableRow key={index}>
                                            <TableCell>
                                                <Skeleton variant="text" width={150} height={30} />
                                            </TableCell>
                                            <TableCell>
                                                <Skeleton variant="text" width={100} height={30} />
                                            </TableCell>
                                            <TableCell>
                                                <Skeleton variant="text" width={120} height={30} />
                                            </TableCell>
                                            <TableCell>
                                                <Skeleton variant="circular" width={24} height={24} />
                                            </TableCell>
                                        </TableRow>
                                    ))
                                ) : filteredUsers && filteredUsers.length > 0 ? (
                                    filteredUsers.map((user, index) => {
                                        return (
                                            <TableRow
                                                key={user.id}
                                                sx={{
                                                    "& .css-1dc80h3-MuiTableCell-root": {
                                                        padding: "12px",
                                                    },
                                                    "& .css-1t595qo-MuiTableCell-root": {
                                                        padding: "12px",
                                                    },
                                                }}
                                            >
                                                <TableCell style={{ borderBottom: "none" }}>
                                                    <div
                                                        style={{ display: "flex", alignItems: "center" }}
                                                    >
                                                        <div
                                                            className={styles.userInitials}
                                                            style={{
                                                                background: theme?.customSettings?.themeColor,
                                                                color: "#ffff",
                                                            }}
                                                        >
                                                            {(user.displayName
                                                                ?.split(" ")
                                                                .map((n) => n[0])
                                                                .join("").toUpperCase() || "N.A.")}
                                                        </div>
                                                        <div>
                                                            <div className={styles.name}>

                                                                {user.displayName || "N.A."}
                                                            </div>

                                                        </div>
                                                    </div>
                                                </TableCell>
                                                {(editRoleAction || deleteRoleAction) &&

                                                    <TableCell
                                                        style={{ borderBottom: "none" }}
                                                        key={user?.id}
                                                    >
                                                        <div
                                                            className={styles.login}
                                                            onClick={(e) => e.stopPropagation()}
                                                        >

                                                            <span
                                                                className={styles.options}
                                                                onClick={(e) => toggleOptions(user?.id, e)}
                                                            >
                                                                {/* <RxDotsHorizontal /> */}
                                                                <HorizontalIcon />
                                                            </span>
                                                            {openOptions && clickedUserId === user?.id && (
                                                                <div
                                                                    className={styles.optionsContainer}
                                                                    ref={inputRef}
                                                                >
                                                                    <div className={styles.createdAt}>
                                                                        Date:{" "}
                                                                        {moment().format(
                                                                            "DD/MM/YY"
                                                                        ) || "N.A."}
                                                                    </div>
                                                                    {editRoleAction &&
                                                                        <button
                                                                            className={styles.optionButton}
                                                                            onClick={() => {
                                                                                handleOpenModal(user);
                                                                                setOpenOptions(false);
                                                                                setClickedUserId(null);
                                                                            }}
                                                                        >
                                                                            <div className={styles.optionsLogo}>
                                                                                {/* <img src={editLogo} alt="" /> */}
                                                                                <EditIcon style={{ width: "20px", height: "20px"}} />
                                                                            </div>
                                                                            Edit Role
                                                                        </button>
                                                                    }

                                                                    {deleteRoleAction &&
                                                                        <button
                                                                            className={styles.optionButton}
                                                                            onClick={() => {
                                                                                confirmDeleteRole(user?.id);
                                                                                setOpenOptions(false);
                                                                                setClickedUserId(null);
                                                                            }}
                                                                        >
                                                                            <div className={styles.optionsLogo}>
                                                                                {/* <img src={deleteLogo} alt="" /> */}
                                                                                <DeleteIcon style={{width:"20px", height:"20px"}} />
                                                                            </div>
                                                                            Delete Role
                                                                        </button>
                                                                    }

                                                                </div>
                                                            )}
                                                        </div>
                                                    </TableCell>
                                                }
                                            </TableRow>
                                        );
                                    })
                                ) : (
                                    <TableRow>
                                        <TableCell
                                            colSpan={4}
                                            align="center"
                                            sx={{
                                                fontSize: "16px",
                                                lineHeight: "24px",
                                                fontWeight: 500,
                                            }}
                                        >
                                            No role found
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "end",
                            justifyContent: "end",
                        }}
                    >

                        {/* <PaginationComponent
              pageNumber={data?.pageNumber || 1}
              totalPages={data?.totalPages || 1}
              onPageChange={setPageNumber}
            /> */}
                    </Box>
                </Box>
            </div>
            <Dialog
                open={confirmOpen}
                onClose={handleCancelDelete}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Delete Role?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this role? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{
                    marginBottom: "20px",
                }}>
                    <Button
                        onClick={handleCancelDelete}
                        variant="outlined"
                        sx={{
                            border: `1px solid ${theme?.customSettings?.themeColor}`,
                            color: theme?.customSettings?.themeColor,
                            fontSize: "16px",
                            fontWeight: 500,
                            lineHeight: "24px",
                            textTransform: "none",
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="submit"
                        onClick={handleConfirmedDelete}
                        variant="contained"
                        sx={{
                            backgroundColor: `${theme?.customSettings?.themeColor}`,
                            border: `1px solid ${theme?.customSettings?.themeColor}`,
                            color: "#fff",
                            fontSize: "16px",
                            fontWeight: 500,
                            lineHeight: "24px",
                            marginRight: "20px",
                            textTransform: "none",
                        }}
                    >
                        Delete
                    </Button>

                    {/* <Button onClick={handleCancelDelete} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleConfirmedDelete} color="error" autoFocus>
                        Delete
                    </Button> */}
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default Role;
